import { Component, ElementRef, OnInit, TemplateRef, Input, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from '../app.service';
import { messageService } from '../message.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Chart } from 'chart.js/auto'
import { PaginationService } from 'src/app/PaginationService';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { qmsService } from '../qms/qms.service';
import { firstValueFrom, forkJoin } from 'rxjs';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { DatePipe } from '@angular/common';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { EditorComponent } from '../editor/editor.component';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
export interface PopupData {
  title: string;
}
interface dropDownInterface {
  codelistCode: any;
  codelistName: any;
}
@Component({
  selector: 'app-tms-user-trainings-report',
  templateUrl: './tms-user-trainings-report.component.html',
  styleUrls: ['./tms-user-trainings-report.component.scss'],
})
export class TmsUserTrainingsReportComponent implements OnInit {
  popupData: PopupData = {
    title: ''
  };
  @Input() tmsReport: any = {};
  @Input() showMarkAsCompleteAndRetake: any;
  ClickedSearchVal: any;
  ClickedStatusVal: any;
  pdfSearchText: string = '';
  isProcessing = false;
  selectedOption: any;
  communicationData: any = {};
  searchUserName: any;
  specificIntervalVal: boolean = false;
  searchUserId: any;
  chosenToUserId: any;
  chosenToUserName: any;
  searchOneQmsUserTrainingsRepVw: any;
  getOneQmsUsersTrainingsRepVwDetails: any = [];
  getOneQmsUsersTrainingsRepVwDetailsUserAndTraining: any = [];
  searchByDepartmentCodeMain = [];
  searchByGroupId = [];
  searchByInstructorTrainer = [];
  selectedInstructorTrainer: any;
  searchVals: any;
  additionalSearchVal: any;
  selectedGroup: any;
  selectedDepartment: any;
  selectedIntervalValue: any = null
  selectedStageValue: any = [];
  selectedGroupValue: any = [];
  totalVal = 0;
  completedVal = 0;
  notCompletedVal = 0;
  overdueVal = 0;
  pendingVal = 0;
  lockedOverdueVal = 0;
  inProgressVal = 0;
  lockedVal = 0;
  failedVal = 0;
  permenantlyLockedVal = 0;
  ScheduledVal = 0;
  type: any;
  repType: any;
  duedate: any;
  comments: any;
  retakeDuedateValue: any;
  popupVal: any;
  dateRangeValueDropdown: any = null;
  childGridShow: any;
  dateCustomClasses: DatepickerDateCustomClasses[];
  afterClickGenrate: boolean = false;
  notCompleted: boolean = false;
  teamUserLevel: boolean = false;
  departmentUserLevel: boolean = false;
  grouphTrainingLevel: boolean = false;
  instructorTrainingLevel: boolean = false;
  stageAndStatus: any = [];
  showTrainerLevel: boolean = false;
  stageValueDropdown: any = [];
  tmsReportchart: any;
  totalList: any = [];
  statusList: any = [];
  colorList: any = [];
  trainingsList: any = [];
  trainingListVal: any;
  heddingListVal: any;
  groupListVal: any;
  fromDate: any;
  toDate: any;
  tableReportDataList: any = [];
  dropDownForInterval: any = [];
  dropDownForDateRange: any = [];
  statusValueDropdown: any = [];
  selectedStatusValue: any = null;
  intervalValueDropdown: any = null;
  selectedDateRangeValue: any = null;
  showSpecificInterval: boolean = false;
  selectedTrainingCategory: any = null;
  selectedTrainingCategoryVals: any;
  categoryCount: any;
  showTables: boolean = false;
  pagedItems2: any;
  showTable: boolean = false;
  categorySearchText: string = '';
  languageSearchText: string = '';
  dateRangeSearchText: string = '';
  intervalSearchText: string = '';
  overdueSearchText: string = '';
  showUserSearchGrid: boolean;
  noUserAlert: boolean = false;
  showInstructorTrainingSearchGrid: boolean;
  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByDesignationCode: any = [];
  searchByDepartmentCode: any = [];
  searchingByStatusCode: any = [];
  designationCodeValue: any;
  departmentCodeValue: any;
  statusCodeValue: any;
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetails: any = [];
  searchUserParentCheckBox: boolean = false;
  currentIndex: any;
  previousIndex: any = null;
  dealingWith: any = false;
  designationListDropdown: any = [];
  departmentListDropdown: any = [];
  selectedDesignationValue: any;
  selectedDepartmentValue: any;
  dropDownForDesignation: any = [];
  dropDownForDepartment: any = [];
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  reportFooterFieldValidation: any;
  constructor(public appService: AppService, public datePipe: DatePipe, public router: Router, public service: messageService, public dialog: MatDialog,
    public snackBar: MatSnackBar, public paginationService: PaginationService, public message: messageService,
    public qmsservice: qmsService, public elem: ElementRef) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    appService.isProcessingRep = false;
  }

  @ViewChild('retakeAndMarkasCompletedPopup', { static: true }) retakeAndMarkasCompletedPopup: TemplateRef<any>;
  visibleretakePopup: MatDialogRef<TemplateRef<any>>;
  retakeAndMarkasCompletedPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  dateFormat: any = this.appService.organizationDetails?.dateFormat ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.dateFormat;
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  changeExpcetedClosureOnDate(items: any) {
    this.retakeDuedateValue = document.getElementById('expcetedClosureOn-validation') as HTMLInputElement;
    if (items != null || items != undefined) {
      if (this.retakeDuedateValue != undefined) {
        this.retakeDuedateValue.style.color = '';
      }
    } else {
      this.retakeDuedateValue.style.color = 'red';
    }
  }

  onTypeChanged(data: any) {
    this.afterClickGenrate = false;
    this.ClickedSearchVal = "";
    this.ClickedStatusVal = "";
    this.searchByDepartmentCodeMain = [];
    this.totalVal = 0;
    this.completedVal = 0;
    this.notCompletedVal = 0;
    this.pendingVal = 0;
    this.lockedOverdueVal = 0;
    this.inProgressVal = 0;
    this.overdueVal = 0;
    this.lockedVal = 0;
    this.failedVal = 0;
    this.permenantlyLockedVal = 0;
    this.ScheduledVal = 0;
    this.tmsUserTrainingsRepVwDataForGrid = [];
    this.searchUserName = "";
    this.getSelectedTrainingName = "";
    this.childGridShow = false;
    this.notCompleted = false;
    this.teamUserLevel = false;
    this.departmentUserLevel = false;
    this.grouphTrainingLevel = false;
    this.instructorTrainingLevel = false;
    this.getOneQmsUsersTrainingsRepVwDetailsUserAndTraining = [];
    this.totalList = [];
    this.statusList = [];
    this.colorList = [];
    if (this.selectedOption == 'Instructor Trainings') {
      this.instructorTrainingLevel = true;
    }
    console.log(data, "data");
  }
  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;
  @ViewChild('searchUserPopup', { static: true }) searchUserPopup: TemplateRef<any>;
  visibleSearchUserPopup: MatDialogRef<TemplateRef<any>>;
  searchUserPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  openSearchUserPopup(value: any) {
    this.totalVal = 0;
    this.completedVal = 0;
    this.notCompletedVal = 0;
    this.pendingVal = 0;
    this.lockedOverdueVal = 0;
    this.inProgressVal = 0;
    this.overdueVal = 0;
    this.lockedVal = 0;
    this.failedVal = 0;
    this.permenantlyLockedVal = 0;
    this.ScheduledVal = 0;
    this.dealingWith = value;
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    [this.searchByDesignationCode, this.searchByDepartmentCode, this.chosenToUserId, this.chosenToUserName] = [[], [], [], []];
    this.popupData.title = "Search User(s)";
    this.visibleSearchUserPopup = this.dialog.open(this.searchUserPopup, this.searchUserPopupConfig);
  }

  selectBoxForDesignation() {
    this.designationListDropdown = [];
    this.designationListDropdown = this.dropDownForDesignation.map((item: dropDownInterface) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }
  selectBoxForDepartment() {
    this.departmentListDropdown = [];
    this.departmentListDropdown = this.dropDownForDepartment.map((item: dropDownInterface) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }
  searchUser() {
    this.isProcessing = true;
    if (this.searchByDesignationCode.length > 0) {
      this.designationCodeValue = this.searchByDesignationCode[0].valueExp;
    } else {
      this.designationCodeValue = null;
    }
    if (this.searchByDepartmentCode.length > 0) {
      this.departmentCodeValue = this.searchByDepartmentCode[0].valueExp;
    } else {
      this.departmentCodeValue = null;
    }
    let searchByUserName = "";
    if (this.searchByUserName) {
      searchByUserName = this.searchByUserName.toUpperCase();
    }
    this.searchOneQmsUserVwDetails = {
      userName: searchByUserName,
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      designationCode: this.designationCodeValue,
      departmentCode: this.departmentCodeValue,
      status: "active"
    };
    this.appService.getOneQmsUsersVwDetails(this.searchOneQmsUserVwDetails).subscribe((data: any) => {
      this.getOneQmsUsersVwDetails = data;
      this.searchUserParentCheckBox = false;
      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }
  onChildCheckBoxChanged(e: any, listOfUsersData: any, idx: any) {
    if (e.target.checked) {
      listOfUsersData.searchUserChildCheckBox = true;
      console.log(listOfUsersData.userId, "--- " + listOfUsersData.userName + "[" + listOfUsersData.emailAddress + "]")
      this.chosenToUserId = listOfUsersData.userId;
      this.chosenToUserName = listOfUsersData.userName;
    }
  }
  onStageValueSelect(item: any) {

    for (let stage of this.stageAndStatus) {
      if (stage.stageName === item.valueExp) {
        const statusArray = stage.listOfStatus.split(',').map((status: string) => status.trim());
        // Use Set to ensure unique values
        this.statusValueDropdown = Array.from(new Set(statusArray));
        break; // exit loop once a match is found
      }
    }
  }
  specificIntervalFun(e: any) {
    if (e.checked) {
      this.specificIntervalVal = true;
      this.showSpecificInterval = true;
      this.fromDate = null;
      this.toDate = null;
      this.selectedDateRangeValue = 'CREATED';
      this.selectedIntervalValue = 'MONTH';
    } else {
      this.specificIntervalVal = false;
      this.showSpecificInterval = false;
    }
  }
  selectBoxForDateRange() {
    this.dateRangeValueDropdown = [];
    this.dateRangeValueDropdown = this.dropDownForDateRange.map((item: { codelistCode: any; codelistName: any; }) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }
  selectBoxForInterval() {
    this.intervalValueDropdown = [];
    this.intervalValueDropdown = this.dropDownForInterval.map((item: { codelistCode: any; codelistName: any; }) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }
  resetSearchManagerGridDataFunction() {
    this.isProcessing = true;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByDesignationCode = [];
    this.searchByDepartmentCode = [];
    this.getOneQmsUsersVwDetails = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }
  setUser() {
    this.afterClickGenrate = false;
    this.noUserAlert = false;
    this.searchUserId = this.chosenToUserId;
    this.searchUserName = this.chosenToUserName;
    this.searchVals = this.searchUserId;
    if (this.searchUserName != "" && this.searchUserName != null && this.searchUserName != undefined) {
      this.visibleSearchUserPopup.close();
    } else {
      this.noUserAlert = true;
    }
  }
  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(data: any, column: string, val: any, view: string) {
    console.log("prim", data);
    this.isProcessing = true;
    const formattedColumn = this.formatColumnName(column);
    this.htmlContent = val;
    this.editorComponent.openEditor(this.htmlContent, formattedColumn);
    this.isProcessing = false;
  }
  formatColumnName(column: string): string {
    return column
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  resetFunction() {
    this.pagedItems7 = [];
    this.pagedItems2 = [];
    this.tableReportDataList = [];
    this.afterClickGenrate = false;
    this.ClickedSearchVal = "";
    this.ClickedStatusVal = "";
    this.searchByDepartmentCodeMain = [];
    this.totalVal = 0;
    this.completedVal = 0;
    this.notCompletedVal = 0;
    this.pendingVal = 0;
    this.lockedOverdueVal = 0;
    this.inProgressVal = 0;
    this.overdueVal = 0;
    this.lockedVal = 0;
    this.failedVal = 0;
    this.permenantlyLockedVal = 0;
    this.ScheduledVal = 0;
    this.tmsUserTrainingsRepVwDataForGrid = [];
    this.searchUserName = "";
    this.chosenToUserId = "";
    this.chosenToUserName = "";
    this.getSelectedTrainingName = "";
    this.childGridShow = false;
    this.notCompleted = false;
    this.teamUserLevel = false;
    this.departmentUserLevel = false;
    this.grouphTrainingLevel = false;
    this.instructorTrainingLevel = false;
    this.getOneQmsUsersTrainingsRepVwDetailsUserAndTraining = [];
    this.totalList = [];
    this.statusList = [];
    this.colorList = [];
    this.selectedGroupValue = "";
    this.specificIntervalVal = false;
    this.selectedTrainingCategory = null;
    this.selectedOverDue = "";
    this.searchByInstructorTrainer = [];
    this.searchByGroupId = [];
    this.pagedItems = [];
    this.selectedDepartment = "";
    this.selectedGroup = "";
    this.searchValue = "";
    this.getSelectedTrainingId = "";
    this.showTable = false;
    this.getSelectedTaskId = "";
    this.getSelectedTaskNo = null;
  }

  async getUsers() {
    this.searchUserId = this.chosenToUserId;
    this.searchUserName = this.chosenToUserName;
    if (this.selectedOption == 'Training Vs Group') {
      this.getSelectedTrainingId = this.getSelectedTrainingId || "All";
      this.isProcessing = true;
      try {

        const [trainingList, heddingList] = await Promise.all([

          firstValueFrom(
            this.appService.getTrainingListForReportFroDynamic(
              'all',
              this.getSelectedTrainingId
            )
          ),

          firstValueFrom(this.appService.getTrainingListForReportFroDynamicHedding('all'))]);

        this.trainingListVal = trainingList;
        this.heddingListVal = heddingList;

        this.calculateTotalPages =
          this.collectionSize / this.perPage;

        this.pager.totalPages = undefined;

        this.collectionSize = this.trainingListVal.length;

        this.totalPages = Math.ceil(
          this.trainingListVal.length / this.itemsPerPage
        );

        this.setPage7(1, 0);

      } catch (error) {

        console.error('Error in forkJoinObservable:', error);

      } finally {

        this.isProcessing = false;

      }
    } else if (this.selectedOption == 'Unmapped Trainings') {
      this.isProcessing = true;
      try {

        const trainingList = await firstValueFrom(
          this.appService.getTrainingListForReport('unmapped'));

        this.trainingsList = trainingList;
        this.calculateTotalPages = this.collectionSize / this.perPage;
        this.pager.totalPages = undefined;
        this.collectionSize = this.trainingsList.length;

        this.totalPages = Math.ceil(
          this.trainingsList.length / this.itemsPerPage
        );

        this.setPage1(1, 0);

      } catch (error) {

        console.error('Error in getTrainingListForReport:', error);

      } finally {

        this.isProcessing = false;

      }

    } else if (this.selectedOption === 'Expiry Date') {

      if (this.selectedOverDue) {

        let wherVal;
        let columnVal;

        console.log(this.selectedOverDue);

        if (this.selectedOverDue === 'DUE IN 7') {
          wherVal = '7';
          columnVal = 'Due';

        } else if (this.selectedOverDue === 'DUE IN 14') {
          wherVal = '14';
          columnVal = 'Due';

        } else if (this.selectedOverDue === 'DUE IN 30') {
          wherVal = '30';
          columnVal = 'Due';

        } else if (this.selectedOverDue === 'DUE IN 90') {
          wherVal = '90';
          columnVal = 'Due';

        } else if (this.selectedOverDue === 'OVER DUE IN 7') {
          wherVal = '7';
          columnVal = 'Over';

        } else if (this.selectedOverDue === 'OVER DUE IN 14') {
          wherVal = '14';
          columnVal = 'Over';

        } else if (this.selectedOverDue === 'OVER DUE IN 30') {
          wherVal = '30';
          columnVal = 'Over';

        } else if (this.selectedOverDue === 'OVER DUE IN 90') {
          wherVal = '90';
          columnVal = 'Over';
        }

        this.isProcessing = true;

        try {

          const trainingList = await firstValueFrom(
            this.appService.getExpiryDateTrainingListForReport(
              wherVal,
              columnVal
            )
          );

          this.trainingsList = trainingList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.trainingsList.length;
          this.totalPages = Math.ceil(
            this.trainingsList.length / this.itemsPerPage
          );

          this.setPage1(1, 0);
          this.showTable = true;

        } catch (error) {

          console.error('Error in getExpiryDateTrainingListForReport:', error);

        } finally {

          this.isProcessing = false;

        }

      } else {
        const field = document.getElementById('overDue') as HTMLInputElement;
        field.style.color = 'red';
      }
    } else if (this.selectedOption == 'Milestone') {
      this.isProcessing = true;
      if (this.selectedTrainingCategory) {
        this.selectedTrainingCategoryVals = "'" + this.selectedTrainingCategory + "'";
      } else {
        this.selectedTrainingCategoryVals = null;
      }
      if (this.fromDate && this.toDate && (this.toDate <= this.fromDate)) {
        alert('To Date cannot be before From Date');
        this.isProcessing = false;
      } else {
        let data = {
          groupId: this.selectedGroupValue[0]?.valueExp ?? null,
          module: "TRN",
          dateRangeAt: this.selectedDateRangeValue ?? null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue ?? null,
          status: this.selectedStatusValue ?? null,
          taskType: this.selectedTrainingCategoryVals,
          taskNo: this.getSelectedTaskNo
        }

        this.isProcessing = true;
        forkJoin([
          this.appService.getTaskMilestonesIntervalsRepVw(data)]).subscribe({
            next: ([MilestonesIntervalsRepVw]) => {
              this.tableReportDataList = MilestonesIntervalsRepVw;
              this.showTables = true;
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.collectionSize = this.tableReportDataList.length;
              this.totalPages = Math.ceil(this.tableReportDataList.length / this.itemsPerPage);
              this.setPage2(1, 0);
              this.isProcessing = false;
            }, error: (error) => {
              this.isProcessing = false;
            }
          });
      }
    }
  }

  setPage2(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tableReportDataList.length, page, this.perPage, targetpage);
    if (this.tableReportDataList.length > 0) {
      this.pagedItems2 = this.tableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall2(value: number) {
    this.perPage = value;
    this.setPage2(this.pager.currentPage, 0);
  }
  setPage1(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.trainingsList.length, page, this.perPage, targetpage);
    if (this.trainingsList.length > 0) {
      this.pagedItems = this.trainingsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall1(value: number) {
    this.perPage = value;
    this.setPage1(this.pager.currentPage, 0);
  }
  pagedItems7: any[];
  setPage7(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.trainingListVal.length, page, this.perPage, targetpage);
    if (this.trainingListVal.length > 0) {
      this.pagedItems7 = this.trainingListVal.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall7(value: number) {
    this.perPage = value;
    this.setPage7(this.pager.currentPage, 0);
  }
  run() {
    console.log("data=====", 3)
    this.isProcessing = true;
    let i = 0;
    this.afterClickGenrate = false;
    this.totalVal = 0;
    this.notCompletedVal = 0;
    this.totalList = [];
    this.statusList = [];
    this.colorList = [];
    this.appService.getOneQmsUserTrainingsRepVw(this.searchOneQmsUserTrainingsRepVw).subscribe((data: any) => {
      this.afterClickGenrate = true;
      this.getOneQmsUsersTrainingsRepVwDetails = data;
      data.forEach((item: any, index: any) => {
        if (item.status === "Completed") {
          this.completedVal = item.count;
          this.totalVal += item.count;
          this.totalList
            .push(this.completedVal);
          this.colorList
            .push("green");
          i++;
        } else if (item.status === "Pending") {
          this.pendingVal = item.count;
          this.notCompletedVal += item.count;
          this.totalVal += item.count;
          if (this.notCompleted) {
            this.totalList
              .push(this.pendingVal);
            this.colorList
              .push("orange");
            i++;
          }
        }
        else if (item.status === "Locked Overdue") {
          this.lockedOverdueVal = item.count;
          this.notCompletedVal += item.count;
          this.totalVal += item.count;
          if (this.notCompleted) {
            this.totalList
              .push(this.lockedOverdueVal);
            this.colorList
              .push("#b5bab6");
            i++;
          }
        }
        else if (item.status === "In Progress") {
          this.inProgressVal = item.count;
          this.notCompletedVal += item.count;
          this.totalVal += item.count;
          if (this.notCompleted) {
            this.totalList
              .push(this.inProgressVal);
            this.colorList
              .push("DodgerBlue");
            i++;
          }
        }
        else if (item.status === "Locked") {
          this.lockedVal = item.count;
          this.notCompletedVal += item.count;
          this.totalVal += item.count;
          if (this.notCompleted) {
            this.totalList
              .push(this.lockedVal);
            this.colorList
              .push("black");
            i++;
          }
        } else if (item.status === "Overdue") {
          this.overdueVal = item.count;
          this.notCompletedVal += item.count;
          this.totalVal += item.count;
          if (this.notCompleted) {
            this.totalList
              .push(this.overdueVal);
            this.colorList
              .push("#b5bab6");
            i++;
          }
        } else if (item.status === "Failed") {
          this.failedVal = item.count;
          this.notCompletedVal += item.count;
          this.totalVal += item.count;
          if (this.notCompleted) {
            this.totalList
              .push(this.failedVal);
            this.colorList
              .push("red");
            i++;
          }
        } else if (item.status === "Permenantly Locked") {
          this.permenantlyLockedVal = item.count;
          this.notCompletedVal += item.count;
          this.totalVal += item.count;
          if (this.notCompleted) {
            this.totalList
              .push(this.permenantlyLockedVal);
            this.colorList
              .push("#fa9696");
            i++;
          }
        } else if (item.status === "Scheduled") {
          this.ScheduledVal = item.count;
          this.notCompletedVal += item.count;
          this.totalVal += item.count;
          if (this.notCompleted) {
            this.totalList
              .push(this.ScheduledVal);
            this.colorList
              .push("#f21ebd");
            i++;
          }
        }

      });
      if (!this.notCompleted) {
        this.totalList
          .push(this.notCompletedVal);
        this.colorList
          .push("red");
        i++;
      }
      this.createChart(this.totalList, this.statusList, this.colorList);

      this.isProcessing = false;
    })
  }
  getUserAndTraining() {
    this.getOneQmsUsersTrainingsRepVwDetailsUserAndTraining = [];
    this.isProcessing = true;
    if (this.selectedOption == 'Team Member Trainings') {
      this.searchOneQmsUserTrainingsRepVw = {

        type: "rm",
        searchValue: this.chosenToUserId.toString()
      };
    }
    this.appService.getOneQmsUserTrainingsRepVwUserLevel(this.searchOneQmsUserTrainingsRepVw).subscribe((data: any) => {
      this.getOneQmsUsersTrainingsRepVwDetailsUserAndTraining = data;
      this.isProcessing = false;
    })
  }

  getGroupUserTraining() {
    this.getOneQmsUsersTrainingsRepVwDetailsUserAndTraining = [];
    this.isProcessing = true;
    if (this.selectedOption == 'Training Groups') {
      console.log("this.selectedOption=", this.selectedOption)
      this.searchOneQmsUserTrainingsRepVw = {

        type: "group",
        searchValue: this.selectedGroup.toString()
      };
      console.log("this.selectedOption=", this.searchOneQmsUserTrainingsRepVw)
    }
    this.appService.getOneQmsUserTrainingsRepVwGroupLevel(this.searchOneQmsUserTrainingsRepVw).subscribe((data: any) => {
      this.getOneQmsUsersTrainingsRepVwDetailsUserAndTraining = data;
      this.isProcessing = false;
    })
  }
  getUserDepartmentlist() {
    this.getOneQmsUsersTrainingsRepVwDetailsUserAndTraining = [];
    this.isProcessing = true;
    if (this.selectedOption == 'Department') {
      this.searchOneQmsUserTrainingsRepVw = {

        type: "department",
        searchValue: this.selectedDepartment
      };
    }
    this.appService.getOneQmsUserTrainingsRepVwDepartmentLevel(this.searchOneQmsUserTrainingsRepVw).subscribe((data: any) => {
      this.getOneQmsUsersTrainingsRepVwDetailsUserAndTraining = data;
      this.isProcessing = false;
    })
  }
  cancelSearchManagerFunction() {
    this.noUserAlert = false;
    this.visibleSearchUserPopup.close();
  }
  //dynamic grid
  snackbarRef: any;
  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  tmsUserTrainingsRepVwDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tmsUserTrainingsRepVwDataForGrid.length, page, this.perPage, targetpage);
    if (this.tmsUserTrainingsRepVwDataForGrid.length > 0) {
      this.pagedItems = this.tmsUserTrainingsRepVwDataForGrid
        .slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }
  getcallMethod() {
    this.tmsUserTrainingsRepVwDataForGrid = [];
    const data = {

      gridName: "USER_TRAINING_REPORT",
      groupId: null
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= '';
        this.makeStickyColumns = response.fixedFieldCnt;
        console.log(this.searchVals);
        const data1: any = {

          gridName: "TMS_USER_TRAININGS_REP_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.tableOrViewName ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          searchVal: this.searchVals,
          additionalSearchVal: this.additionalSearchVal,
          searchStatus: this.type,
          repType: this.repType,
          manualEntryDataFields: response.manualEntryDataFields
        }

        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.tmsUserTrainingsRepVwDataForGrid = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];

            this.columnLists.fieldSizeListArray = data1.fieldSizeListArray.map((size: any) => size + 'px');
            const invisibleSet = new Set(this.columnLists.invisibleColumnarray); // Use Set for faster lookups

            this.columnLists.columnsListarray = this.columnLists.columnsListarray.filter((item: any, index: any) => {
              if (invisibleSet.has(item)) {
                this.columnLists.fieldColumnarray.splice(index, 1);
                this.columnLists.fieldSizeListArray.splice(index, 1);
                return false; // Remove the element from columnsListarray
              }
              return true; // Keep the element in columnsListarray
            });

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              this.columnLists.columnsListarray1 = this.columnLists.columnsListarray.map((column: any, index: string | number) => {
                // Find the matching data type
                const matchingDataType = this.dataTypeList.find((item: { columnName: any; }) => item.columnName === column);

                return {
                  columnsListarray: column,
                  dataType: matchingDataType ? matchingDataType.fieldType : "textbox",
                  width: this.columnLists.fieldSizeListArray[index] // Ensure width is set per column
                };
              });
              const checkboxFields = this.dataTypeList.filter((item: { fieldType: string; }) => item.fieldType === 'CHECKBOX');
              for (const row of this.tmsUserTrainingsRepVwDataForGrid) {
                for (const field of checkboxFields) {
                  row[field.columnName] = row[field.columnName] === "Y";
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.tmsUserTrainingsRepVwDataForGrid;
            this.collectionSize = this.tmsUserTrainingsRepVwDataForGrid.length;
            this.totalPages = Math.ceil(this.tmsUserTrainingsRepVwDataForGrid.length / this.itemsPerPage);
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.tmsUserTrainingsRepVwDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.tmsUserTrainingsRepVwDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

    // Dismiss the snackbar if it exists
    this.snackbarRef?.dismiss();
    // Get the template name from the clicked element's inner text
    const templateName = event.target.innerText;
    // Filter out the relevant template data based on the template name
    const filteredQmsQuestionnaireTemplateData = this.tmsUserTrainingsRepVwDataForGrid.filter(
      (x: any) => x.TEMPLATE_NAME === templateName
    );
    // Ensure the filtered data exists before accessing it
    if (filteredQmsQuestionnaireTemplateData.length > 0) {
      this.message.templateIdFromQmsQuestionnaireTemplate = filteredQmsQuestionnaireTemplateData[0].TEMPLATE_ID;
    }
    // Navigate to the desired route
    this.router.navigate(['dashboard/qmsQuestionnaireTemplateQuestion']);
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  visibleAddButton: boolean;
  visibleEditButton: boolean;



  //search training
  popupDataTitle: PopupData = {
    title: ''
  };
  trainingGroupTrainingFieldData: any = {};
  operationFlag: any;
  popupTitle: string | null = 'title';
  @ViewChild('searchTraining', { static: true }) searchTraining: TemplateRef<any>;
  visibleSearchTrainingPopup: MatDialogRef<TemplateRef<any>>;
  searchByTrainingName: any = null;
  searchByTrainingCode: any = null;
  searchByCategory: any = null;
  searchByLanguage: any = null;
  categoryValue: any;
  languageValue: any;
  searchTmsTrainingsVwDetails: any;
  getTmsTrainingDetailsTableData: any = [];
  searchTrainingConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '05px' },
  };

  searchTrainingFunction() {
    this.getSelectedTrainingId = null;
    this.getSelectedTrainingName = '';
    this.multiUsersArray = [];
    this.showUserSearchGrid = false;
    this.searchByTrainingName = null;
    this.searchByTrainingCode = null;
    this.searchByCategory = null;
    this.searchByLanguage = null;
    this.popupDataTitle.title = "Search Training";
    this.visibleSearchTrainingPopup = this.dialog.open(this.searchTraining, this.searchTrainingConfig);
  }


  categoryDropdown: any = [];
  languageDropdown: any = [];

  selectBoxeForCategory() {
    this.categoryDropdown = [];
    for (const category of this.dropDownForCategories) {
      this.categoryDropdown = this.categoryDropdown.concat({
        valueExp: category.trainingCategoryCode,
        displayExp: category.trainingCategoryName
      });
    }
  }
  selectBoxeForLanguage() {
    for (const language of this.dropDownForLangauge) {
      this.languageDropdown = this.languageDropdown.concat({
        valueExp: language.codelistCode,
        displayExp: language.codelistName
      });
    }
  }
  selectedCategoryValue: any = null;
  selectedLanguageValue: any = null;
  selectedLevelValue: any;
  selectedTemplateValue: any;
  onCategorySelectNew(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.selectedCategoryValue = item.valueExp;
      })
    }
  }
  onLangaugeSelectNew(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.selectedLanguageValue = item;
      })
    }
  }
  cancelSearchTrainingFunction() {
    this.getSelectedTrainingId = null;
    this.getSelectedTrainingName = '';
    this.getSelectedVersion = null;
    this.noUserAlert = false;
    this.visibleSearchTrainingPopup.close();
  }
  searchTrainingGridDataFunction() {
    this.isProcessing = true;
    if (this.searchByCategory) {
      this.categoryValue = this.searchByCategory;
    } else {
      this.categoryValue = null;
    }
    if (this.searchByLanguage) {
      this.languageValue = this.searchByLanguage;
    } else {
      this.languageValue = null;
    }
    this.searchTmsTrainingsVwDetails = {
      trainingName: this.searchByTrainingName,
      trainingCode: this.searchByTrainingCode,
      category: this.categoryValue,
      language: this.languageValue,
      groupId: null
    };
    this.appService.searchTrainingsByCondition(this.searchTmsTrainingsVwDetails).subscribe((response: any) => {
      this.getTmsTrainingDetailsTableData = response;
      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }
  resetSearchTrainingGridDataFunction() {
    this.isProcessing = true;
    this.searchByTrainingName = null;
    this.searchByTrainingCode = null;
    this.searchByCategory = null;
    this.searchByLanguage = null;
    this.getTmsTrainingDetailsTableData = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
    this.multiUsersArray = [];
  }
  getSelectedTrainingId: any;
  getSelectedTrainingName: string;
  getSelectedVersion: any;
  multiUsersArray: any = [];
  searchTrainingChildCheckBoxChecked(e: any, listOfTrainingsVwDetails: any, idx: any) {
    if (e.target.checked) {
      listOfTrainingsVwDetails.searchTrainingChildCheckBoxs = true;
      if (!this.multiUsersArray.some((storedUser: any) => storedUser.trainingId === listOfTrainingsVwDetails.trainingId)) {
        this.multiUsersArray.push({ trainingId: listOfTrainingsVwDetails.trainingId, trainingName: listOfTrainingsVwDetails.trainingName });
      }
    } else {
      listOfTrainingsVwDetails.searchTrainingChildCheckBoxs = false;
      const removal = this.getTmsTrainingDetailsTableData.findIndex((removableUser: any) => removableUser.trainingId == listOfTrainingsVwDetails.trainingId);
      if (removal > -1) this.multiUsersArray.splice(removal, 1);
      if (this.getTmsTrainingDetailsTableData.some((allUsers: any) => !allUsers.searchUserChildCheckBox)) {
        this.searchUserParentCheckBox = false;
      }
    }
  }

  addTrainingNameFunction() {
    this.afterClickGenrate = false;
    this.noUserAlert = false;
    this.getSelectedTrainingId = this.multiUsersArray.map((tr: any) => tr.trainingId).join(',');
    this.getSelectedTrainingName = this.multiUsersArray.map((tr: any) => tr.trainingName).join(',');
    this.searchVals = this.getSelectedTrainingId;
    if (this.searchVals != "" && this.searchVals != null && this.searchVals != undefined) {
      this.visibleSearchTrainingPopup.close();
    } else {
      this.noUserAlert = true;
    }
  }
  groupValueDropdown: any;
  selectBoxeForGroupValue() {
    this.groupValueDropdown = [];
    console.log("this.groupdataList=", this.groupdataList);
    for (const group of this.groupdataList) {
      this.groupValueDropdown = this.groupValueDropdown.concat({
        valueExp: group.groupId,
        displayExp: group.groupName
      });
    }
  }
  getTmsInstructorTrainerDataList: any;
  selectBoxeForTrainerValue() {
    this.getTmsInstructorTrainerDataList = [];
    console.log("getTmsInstructorTrainerData=", this.getTmsInstructorTrainerData)
    for (const trainer of this.getTmsInstructorTrainerData) {
      this.getTmsInstructorTrainerDataList = this.getTmsInstructorTrainerDataList.concat({
        valueExp: trainer.trainerId,
        displayExp: trainer.trainerName
      });
    }
  }
  isAnyColumnSelected(): boolean {
    return this.parentCheckBox || this.pagedItems.some(item => item.childCheckBoxs);
  }
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
  openFileDialog() {
    this.fileInput.nativeElement.click();
  }
  file: any;
  fileExtension: any;
  filename: any;
  cancelRetakeAndMarkasCompletedFunc() {
    this.visibleretakePopup.close();
  }
  cancelExportPopup() {
    this.visibleretakePopup.close();
  }
  statusData = [{
    status: "Completed",
    trainingCount: 0,
    color: "#97C95C"
  }, {
    status: "Not Completed",
    trainingCount: 0,
    color: "#ebb434"
  }, {
    status: "Not Completed-Over Due",
    trainingCount: 0,
    color: "#F5564A"
  }];
  createChart(totalList: any, statusList: any, colorList: any) {
    if (this.tmsReportchart) {
      this.tmsReportchart.destroy();
    }
    this.tmsReportchart = new Chart("MyReportChart", {
      type: 'pie', //this denotes tha type of chart
      data: {// values on X-Axis
        datasets: [{
          data: totalList,
          backgroundColor: colorList,
          hoverOffset: 4,
        }],
      },
      options: {
        responsive: true,
        cutout: '0%',
        plugins: {
          tooltip: {
            enabled: true
          },
        },
        elements: {
        }
      }
    });
  }
  //init
  dropDownForCategories: any = [];
  getTmsInstructorTrainerData: any = [];
  dropDownForLangauge: any = [];
  groupdataList: any = [];
  cards: any = [];
  labels: any = [];
  icons: any;
  selectedOverDue: any = null;
  dropDownForOverDue: any = [];
  overDueDropDown: any = [];
  selectBoxForOverDue() {
    this.overDueDropDown = [];
    this.overDueDropDown = this.dropDownForOverDue?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })) || []
  }

  handleDropDownValidation(fieldId: string, selectedItems: any[]) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = (['execl-pdf'].includes(fieldId) && (!selectedItems.length || !selectedItems)) && field ? 'red' : '#005c8a';
  }
  moreActivityReportDetails(val: any, pageVal: any) {
    this.service.tmsReportButtonVal = val;
    if (pageVal == 1) {
      this.router.navigate(['/dashboard/tmsReport']);
    } else {
      this.selectedOption = val;
    }
    if (this.selectedOption == 'Unmapped Trainings') {
      this.getUsers();
    }
    pageVal == 3 && this.router.navigate(['/dashboard/trainingsConclusiveTrail']);
    this.selectedOption = this.service.tmsReportButtonVal;
    this.afterClickGenrate = false;
    this.ClickedSearchVal = "";
    this.ClickedStatusVal = "";
    this.searchByDepartmentCodeMain = [];
    this.totalVal = 0;
    this.completedVal = 0;
    this.notCompletedVal = 0;
    this.pendingVal = 0;
    this.lockedOverdueVal = 0;
    this.inProgressVal = 0;
    this.overdueVal = 0;
    this.lockedVal = 0;
    this.failedVal = 0;
    this.permenantlyLockedVal = 0;
    this.ScheduledVal = 0;
    this.tmsUserTrainingsRepVwDataForGrid = [];
    this.searchUserName = "";
    this.getSelectedTrainingName = "";
    this.childGridShow = false;
    this.notCompleted = false;
    this.teamUserLevel = false;
    this.departmentUserLevel = false;
    this.grouphTrainingLevel = false;
    this.instructorTrainingLevel = false;
    this.getOneQmsUsersTrainingsRepVwDetailsUserAndTraining = [];
    this.totalList = [];
    this.statusList = [];
    this.colorList = [];
    this.tableReportDataList = "";
    this.trainingListVal = "";
    this.pagedItems7 = [];
    this.pagedItems2 = [];
    this.selectedGroupValue = "";
    this.specificIntervalVal = false;
    this.selectedTrainingCategory = null;
    this.selectedOverDue = null;
    this.searchByInstructorTrainer = [];
    this.searchByGroupId = [];
    this.pagedItems = [];
    this.selectedDepartment = "";
    this.selectedGroup = "";
    this.searchValue = "";
    this.getSelectedTrainingId = "";
  }
  getSelectedTaskId: any;
  getSelectedTaskNo: any;
  getTaskDetailsObj: any = [];
  getTaskDetailsObj1: any = [];
  privvalue: any;
  @ViewChild('searchTaskVW', { static: true }) searchTaskVW: TemplateRef<any>;
  visibleSearchTaskVwPopup: MatDialogRef<TemplateRef<any>>;
  searchTaskVWConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  searchTaskVwFunction() {
    this.popupDataTitle.title = "Select Task ID";
    this.isProcessing = true;
    this.appService.getQmsAllTasksVw("TRN").subscribe((data: any) => {
      this.getTaskDetailsObj = data;
      this.getTaskDetailsObj1 = data;
      this.isProcessing = false;
    })
    this.visibleSearchTaskVwPopup = this.dialog.open(this.searchTaskVW, this.searchTaskVWConfig);
  }
  cancelAllTaskVwFunction() {
    this.getSelectedTaskId = null;
    this.getSelectedTaskNo = '';
    this.visibleSearchTaskVwPopup.close();
  }
  searchTaskVwChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {
    if (e.target.checked) {
      if (this.privvalue != undefined) {
        this.getTaskDetailsObj[this.privvalue].searchManagerChildCheckBoxs = false;
      }
      listOfUsersVwDetails.searchManagerChildCheckBoxs = true;
      this.getSelectedTaskId = listOfUsersVwDetails.taskId;
      this.getSelectedTaskNo = listOfUsersVwDetails.taskNo;
    } else {
      listOfUsersVwDetails.searchManagerChildCheckBoxs = false;
      this.getSelectedTaskId = "";
      this.getSelectedTaskNo = null;
    }
    this.privvalue = idx;
  }

  addTaskVwGridDataFunction() {
    console.log(this.getSelectedTaskId + "====" + this.getSelectedTaskNo);
    this.visibleSearchTaskVwPopup.close();
  }
  applyFilter6(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.getTaskDetailsObj1 = this.getTaskDetailsObj;
    } else {
      this.getTaskDetailsObj1 = this.getTaskDetailsObj.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (typeof columnValue === 'string') {
          console.log("columnValue1=", columnValue);
          return columnValue.toLowerCase().includes(filter);
        }
        return false;
      });
    }
  }
  applyFilter1(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    console.log(column + "=====" + filter + "====" + val)
    if (filter === '') {
      this.pagedItems = this.trainingsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.trainingsList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }

  applyFilter(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    console.log(column + "=====" + filter + "====" + val)
    if (filter === '') {
      this.pagedItems2 = this.tableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems2 = this.tableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;

  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      console.log("this.dropDownDataForReportLogo=", this.dropDownDataForReportLogo);
      console.log("this.dropDownDataForReportLogo.reportImageList", this.dropDownDataForReportLogo.reportImageList);
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            console.log("this.imageIdList=", this.imageIdList);
            console.log("this.organizationReportImageDetails=", this.organizationReportImageDetails.length);
            for (const reportImage of this.organizationReportImageDetails) {

              console.log(
                'this.organizationReportImageDetails=',
                reportImage.reportImageId,
                this.imageIdList[i]
              );

              if (reportImage.reportImageId === this.imageIdList[i]) {

                this.reportLogoDropdown = this.reportLogoDropdown.concat({
                  valueExp: reportImage.reportImageId,
                  displayExp: reportImage.reportImageName
                });

              }
            }
          }
        }
      } else {
        for (const reportImage of this.organizationReportImageDetails) {

          if (
            reportImage.reportImageId ===
            this.dropDownDataForReportLogo.reportImageList
          ) {

            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: reportImage.reportImageId,
              displayExp: reportImage.reportImageName
            });

          }
        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const reportLogo of this.reportLogoDropdown) {

          if (
            reportLogo.valueExp ===
            this.dropDownDataForReportLogo.defaultReportName
          ) {

            this.selectedReportLogoValue = reportLogo.valueExp;

          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next:
        (data: any) => {
          this.reportFooterDropdown1 = data;
          console.log("data", this.reportFooterDropdown1);

          this.selectBoxForFooter();
          if (this.reportFooterDropdown.length > 0) {
            this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
          }

          this.isProcessing = false;
        }, error:
        (error: any) => {
          this.isProcessing = false;
        }
    });
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes("TRN")) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
        // }
      }
    }
  }


  ngOnInit() {
    this.selectedOption = this.service.tmsReportButtonVal;
    this.afterClickGenrate = false;
    this.ClickedSearchVal = "";
    this.ClickedStatusVal = "";
    this.searchByDepartmentCodeMain = [];
    this.totalVal = 0;
    this.completedVal = 0;
    this.notCompletedVal = 0;
    this.pendingVal = 0;
    this.lockedOverdueVal = 0;
    this.inProgressVal = 0;
    this.overdueVal = 0;
    this.lockedVal = 0;
    this.failedVal = 0;
    this.permenantlyLockedVal = 0;
    this.ScheduledVal = 0;
    this.tmsUserTrainingsRepVwDataForGrid = [];
    this.searchUserName = "";
    this.getSelectedTrainingName = "";
    this.childGridShow = false;
    this.notCompleted = false;
    this.teamUserLevel = false;
    this.departmentUserLevel = false;
    this.grouphTrainingLevel = false;
    this.instructorTrainingLevel = false;
    this.getOneQmsUsersTrainingsRepVwDetailsUserAndTraining = [];
    this.totalList = [];
    this.statusList = [];
    this.colorList = [];
    if (this.selectedOption == 'Organization') {
      this.getUsers();
    }
    if (this.selectedOption == 'Unmapped Trainings') {
      this.getUsers();
    }
    this.appService.getAllCategoriesList()
      .subscribe((data: any) => {
        const uniqueData = data.filter((item: any, index: number, self: any) =>
          index === self.findIndex((t: any) => t.trainingCategoryName === item.trainingCategoryName)
        );
        this.dropDownForCategories = uniqueData;
        this.selectBoxeForCategory();
      });
    this.appService.getCodeListsByGroup("TRAINING_LANGUAGE").subscribe((data: any) => {
      this.dropDownForLangauge = data;
      this.selectBoxeForLanguage();
    })

    this.appService.getTmsGroupsVwDetails().subscribe((response: any) => {
      this.groupdataList = response;
      console.log(this.groupdataList)
      this.selectBoxeForGroupValue();
    });

    this.appService.getInstructorTrainer().subscribe((response: any) => {
      this.getTmsInstructorTrainerData = response;
      this.selectBoxeForTrainerValue();
    })

    this.dropDownForDesignation = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') ?? '{}');
    this.dropDownForDepartment = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');
    this.selectBoxForDepartment();
    this.selectBoxForDesignation();


    this.appService.getCodeListsByGroup('REB_DUE_DROPDOWN_VAL').subscribe((data: any) => {
      this.dropDownForOverDue = data
      this.selectBoxForOverDue();
    })

    this.appService.getCodeListsByGroup('REPORT_DATE_RANGE').subscribe((data: any) => {
      this.dropDownForDateRange = data
      this.selectBoxForDateRange();
    })
    this.appService.getCodeListsByGroup('REPORT_INTERVAL').subscribe((data: any) => {
      this.dropDownForInterval = data
      this.selectBoxForInterval();
    })


    this.isProcessing = true;
    this.appService.getOneQmsOrganizationReportImage().subscribe({
      next: (data: any) => {
        this.organizationReportImageDetails = data;
        this.appService.getQmsReportLogoByModuleAndGroupId("TRN", 0).subscribe((data: any) => {
          this.dropDownDataForReportLogo = data;
          this.selectBoxForReportLogo();
          this.isProcessing = false;
        });
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    })
    this.ngOnChangesReportFooter();

  }

  //Excell & PDF
  whereValsForExcel: any;
  whereValsForExcelTemp: any;
  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    this.manuallyPicked = false;
    this.selectedColumns = "";
  }

  selectedColumns: any;
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  reportObj: any = {};
  pdfDetailSearchText: string = '';
  templateid: number;
  reportTemplateFieldValidation: any;
  reportLogoFieldValidation: any;
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }
    }
  }
  reportName: any;
  isSaveReport: boolean = false;
  generateReport(value: any) {
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else {

      this.appService.isProcessingRep = true;
      let tname = "";
      let colList = "";
      let fieldList = "";
      let whereVals = "";
      this.whereValsForExcel = "";
      if (this.selectedOption == 'Milestone') {
        tname = "ONEQMS_TASK_MILESTONES_INTERVALS_REP_VW";
        colList = "TASK_DETAILS,CURRENT_STATUS,VERSION,TASK_TYPE,CREATED_ON,STARTED_ON,COMPLETED_ON,PUBLISHED_ON,REVIEW_REQUESTED_ON,REVIEW_COMPLETED_ON,APPROVAL_REQUESTED_ON,APPROVAL_COMPLETED_ON";
        fieldList = "Training Name,Status,Version,Category,Created On,Started On,Completed On,Published On,Review Requested On,Review Completed On,Approval Requested On,Approval Completed On";
        whereVals = " WHERE ORG_ID=" + this.message.getOrgId();
        if (this.selectedTrainingCategory) {
          if (this.selectedTrainingCategory != '') {
            whereVals += " AND TASK_TYPE='" + this.selectedTrainingCategory + "'";
          }
        }
        if (this.getSelectedTaskNo) {
          whereVals += " AND (TASK_NO='" + this.getSelectedTaskNo + "' OR PARENT_TASK_NO='" + this.getSelectedTaskNo + "')";
        }
      } else if (this.selectedOption == 'Unmapped Trainings') {
        tname = "TMS_TRAINING_GROUPLIST_REP_VW";
        colList = "TRAINING_NAME,TRAINING_CODE,VERSION,CATEGORY_CODE,TYPE,STATUS,IS_LATEST_VERSION,IS_LATEST_PUBLISHED_VERSION";
        fieldList = "Training Name,Training Code,Version,Category,Type,Status,Is Latest Version,Is Latest Published Version";
        whereVals = " WHERE STATUS='Published' AND USER_GROUP_LIST IS NULL";
      } else if (this.selectedOption == 'Expiry Date') {
        if (this.selectedOverDue == "DUE IN 7") {
          whereVals = " WHERE EXPIRY_DATE > SYSDATE AND EXPIRY_DATE <= (SYSDATE+" + 7 + ")";
        } else if (this.selectedOverDue == "DUE IN 14") {
          whereVals = " WHERE EXPIRY_DATE > SYSDATE AND EXPIRY_DATE <= (SYSDATE+" + 14 + ")";
        } else if (this.selectedOverDue == "DUE IN 30") {
          whereVals = " WHERE EXPIRY_DATE > SYSDATE AND EXPIRY_DATE <= (SYSDATE+" + 30 + ")";
        } else if (this.selectedOverDue == "DUE IN 90") {
          whereVals = " WHERE EXPIRY_DATE > SYSDATE AND EXPIRY_DATE <= (SYSDATE+" + 90 + ")";
        } else if (this.selectedOverDue == "OVER DUE IN 7") {
          whereVals = " WHERE EXPIRY_DATE < SYSDATE AND EXPIRY_DATE >= (SYSDATE-" + 7 + ")";
        } else if (this.selectedOverDue == "OVER DUE IN 14") {
          whereVals = " WHERE EXPIRY_DATE < SYSDATE AND EXPIRY_DATE >= (SYSDATE-" + 14 + ")";
        } else if (this.selectedOverDue == "OVER DUE IN 30") {
          whereVals = " WHERE EXPIRY_DATE < SYSDATE AND EXPIRY_DATE >= (SYSDATE-" + 30 + ")";
        } else if (this.selectedOverDue == "OVER DUE IN 90") {
          whereVals = " WHERE EXPIRY_DATE < SYSDATE AND EXPIRY_DATE >= (SYSDATE-" + 90 + ")";
        }
        whereVals = whereVals + " AND ORG_ID=" + this.message.getOrgId();
        tname = "TMS_TRAININGS_VW";
        colList = "TRAINING_NAME,TRAINING_CODE,CATEGORY_CODE,EXPIRY_IN_DAYS,EXPIRY_DATE,DESCRIPTION,IS_LATEST_VERSION,IS_LATEST_PUBLISHED_VERSION,TYPE,TOTAL_DURATION,LANGUAGE,STATUS,PUBLISHED_BY_USER,PUBLISHED_ON,UPDATED_BY_USER,UPDATED_ON,CREATED_BY_USER,CREATED_ON,LAST_ACTION_FROM_STATUS,LAST_ACTION_COMMENTS,LAST_ACTION_BY_USER,LAST_ACTION_ON,INTIMATE_EXPIRY_BEFORE_IN_DAYS,SELF_ASSIGNABLE";
        fieldList = "Training Name,Training Code,Category Code,Expiry In Days,Expiry Date,Description,Is Latest Version,Is Latest Published Version,Type,Total Duration,Language,Status,Published By,Published On,Updated By,Updated On,Created By,Created On,Last Action From Status,Last Action Comments,Last Action By,Last Action On,Intimate Expiry Before In Days,Self Assignable";
      }

      this.whereValsForExcel = whereVals;

      console.log(value, "--------------------");
      const data = {
        groupId: this.qmsservice.selectedGroup
      }
      if (this.selectedOption == 'Milestone') {
        const data1: any = {
          tableOrViewName: tname,
          columnsList: colList,
          fieldLabelsList: fieldList,
          invisibleColumn: "",
          orderByClause: "",
          fieldSizeList: "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          status: this.statusCodeValue,
          codelistGroup: null,
          manualEntryDataFields: null,
          groupId: this.qmsservice.selectedActivityGroupId,
          chartStatus: null,
          wherVal: this.whereValsForExcel,
          reModule: "tmsM",
          footer: this.selectedReportFooter,
          logoId: this.selectedReportLogoValue ?? 0,
          isSaveRep: this.isSaveReport ? 'Y' : 'N',
          reportName: this.reportName ?? "Report",
          currentStatus: "NA",
          groupName: "",
        }
        let data2 = {

          groupId: this.selectedGroupValue[0]?.valueExp ?? null,
          module: "TRN",
          dateRangeAt: this.selectedDateRangeValue ?? null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue ?? null,
          status: this.selectedStatusValue ?? null
        }
        this.reportObj = { ...data1, ...data, ...data2 };
      } else {
        const data1: any = {

          tableOrViewName: tname,
          columnsList: colList,
          fieldLabelsList: fieldList,
          invisibleColumn: "",
          orderByClause: "",
          fieldSizeList: "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          status: this.statusCodeValue,
          codelistGroup: null,
          manualEntryDataFields: null,
          groupId: this.qmsservice.selectedActivityGroupId,
          chartStatus: null,
          wherVal: this.whereValsForExcel,
          reModule: "tms",
          module: "TRN",
          footer: this.selectedReportFooter,
          logoId: this.selectedReportLogoValue ?? 0,
          isSaveRep: this.isSaveReport ? 'Y' : 'N',
          reportName: this.reportName ?? "Report",
          currentStatus: "NA",
          groupName: "",
        }
        this.reportObj = { ...data1, ...data }
      }
      debugger;
      if (value == 'Excel') {
        const pdfData = {
          ...this.reportObj, title: this.selectedOption, columns: [],
          "informationTab": {
            "Report Name": this.selectedOption,
            "Exported By": localStorage.getItem("loggedUserName")
          }
        }
        this.appService.downloadexcelForChart(pdfData, this.selectedOption + ".xlsx");
      } else {
        const pdfData = {
          ...this.reportObj, title: this.selectedOption, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
        }
        this.appService.downloadPdfForChart(pdfData, this.selectedOption + ".pdf");
      }
    }
  }
  generateReportForTrainingVsGroup(value: any) {
    this.appService.isProcessingRep = true;
    let tname = "";
    let colList = "";
    let fieldList = "";
    let whereVals = "";
    this.whereValsForExcel = "";
    tname = "TMS_TRAINING_GROUPLIST_REP_VW";
    colList = "TRAINING_CODE,TRAINING_NAME,VERSION,STATUS,IS_LATEST_PUBLISHED_VERSION";
    fieldList = "Training Code,Training Name,Version,Status,Is Latest Published Version";
    whereVals = this.getSelectedTrainingId ? this.getSelectedTrainingId : "All";
    this.whereValsForExcel = whereVals;
    console.log(value, "--------------------");
    const data = {

      groupId: null
    }
    const data1: any = {

      tableOrViewName: tname,
      columnsList: colList,
      fieldLabelsList: fieldList,
      invisibleColumn: "",
      orderByClause: "",
      fieldSizeList: "",
      columnsListarray: [],
      fieldColumnarray: [],
      invisibleColumnarray: [],
      fieldSizeListArray: [],
      status: this.statusCodeValue,
      codelistGroup: null,
      manualEntryDataFields: null,
      groupId: null,
      chartStatus: null,
      wherVal: this.whereValsForExcel,
      reModule: "tms",
      logoId: this.selectedReportLogoValue ?? null,
      isSaveRep: this.isSaveReport ? 'Y' : 'N',
      reportName: this.reportName ?? "Report",
      currentStatus: "NA",
      groupName: "",
    }
    this.reportObj = { ...data1, ...data }

    const pdfData = {
      ...this.reportObj, title: this.selectedOption, columns: [],
      "informationTab": {
        "Report Name": this.selectedOption,
        "Exported By": localStorage.getItem("loggedUserName")
      }
    }
    this.appService.downloadexcelFoTrainingVsGroup(pdfData, this.selectedOption + ".xlsx");
  }


  openReportPopupForTrainingVsGroup(item: any) {
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') || '{}');
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    this.pdfSelection = false;
    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.isSaveReport = false;
  }
  openReportPopup(item: any) {
    if (this.selectedOption == 'Milestone') {
      this.columnList = "Training Name,Status,version,Category,Created On,Started On,Completed On,Published On,Review Requested On,Review Completed On,Approval Requested On,Approval Completed On";
    } else if (this.selectedOption == 'Unmapped Trainings') {
      this.columnList = "Training Name,Training Code,Version,Category,Type,Status,Is Latest Version,Is Latest Published Version";
    } else if (this.selectedOption == 'Expiry Date') {
      this.columnList = "Training Name,Training Code,Category Code,Expiry In Days,Expiry Date,Description,Is Latest Version,Is Latest Published Version,Type,Total Duration,Language,Status,Published By,Published On ,Updated By,Updated On,Created By,Created On,Last Action From Status,Last Action Comments,Last Action By,Last Action On,Intimate Expiry Before In Days,Self Assignable";
    }
    this.excelPdf.dropDown = this.columnList.split(',').map((column: any) => ({ valueExp: column, displayExp: column }));
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') || '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    this.pdfSelection = false;
    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.isSaveReport = false;
  }
  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.isAllColumns = this.selectedColumns.length == this.excelPdf.dropDown.length;
      });
    }
  }
  //end excell & pdf
  manuallyPicked: boolean;
  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  pdfPageSizes: any = [];
  @Input() excelPdf: any = {};
  onSelect() {
    if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(this.selectedColumns);
  }
  @ViewChild('pdf') pdf: MatSelect;
  pdfSelection = false;
  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }
  toggleAllSelection(value: any) {
    if (value == 'pdf') {
      if (this.pdfSelection) this.pdf.options.forEach((item: MatOption) => item.select());
      else {
        this.pdf.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];

      }
      setTimeout(() => {
        this.handleDropDownValidation('execl-pdf', this.selectedColumns)
        this.convertArrayToString(this.selectedColumns);
      });

    }
    console.log("pdf", this.selectedColumns)
  }
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ??
          this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  @ViewChild('captureDiv') captureDiv!: ElementRef;
  captureElement(): void {
    const element = this.captureDiv.nativeElement;
    html2canvas(element, {
      scrollX: -window.scrollX,
      scrollY: -window.scrollY,
      windowWidth: document.documentElement.offsetWidth,
      windowHeight: document.documentElement.offsetHeight,
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save(this.selectedOption + '-Groups.pdf');
    });
  }
}
